class AppLoadTimer {
  static instance = null;

  static arrayMessage = [];

  constructor() {
    if (AppLoadTimer.instance) {
      return AppLoadTimer.instance;
    }

    this.startTime = performance.now();

    AppLoadTimer.instance = this;
  }

  /**
   * Log a timing message relative to application startup.
   *
   * @param {string} message
   */
  log(message) {

    if(AppLoadTimer.arrayMessage.indexOf(message) > -1)
      return
    
    const elapsedSeconds = (performance.now() - this.startTime) / 1000;

    console.log(
      `[AppLoadTimer] ${message} — after ${elapsedSeconds.toFixed(2)} seconds`,
    );

    AppLoadTimer.arrayMessage.push(message);
  }

  /**
   * Reset the timer.
   * Useful if you want to start a new measurement cycle.
   */
  reset() {
    this.startTime = performance.now();
  }
}

export default new AppLoadTimer();

